import logger from '@redbubble/next-logger';
import { sessionStorage } from '@redbubble/persistent-storage';
import { useEffect } from 'react';
import { useRudderstackClient } from './rudderstack-provider';
var IDENTIFY_THROTTLE_KEY = 'rs_last_identify';
var IDENTIFY_THROTTLE_MS = 15 * 60 * 1000; // 15 minutes
function shouldIdentify(identifyCallProps) {
    try {
        var raw = sessionStorage.getItem(IDENTIFY_THROTTLE_KEY);
        if (!raw)
            return true;
        var prev = JSON.parse(raw);
        if (prev.federatedId !== identifyCallProps.federatedId)
            return true;
        if (Date.now() - prev.ts > IDENTIFY_THROTTLE_MS)
            return true;
        return false;
    }
    catch (err) {
        var message = 'Session storage read failed for identify throttle check';
        logger.warn({ err: err, message: message, context: 'RudderstackDefaultTracking' }, message);
        return true;
    }
}
function recordIdentify(identifyCallProps) {
    try {
        sessionStorage.setItem(IDENTIFY_THROTTLE_KEY, JSON.stringify({
            ts: Date.now(),
            federatedId: identifyCallProps.federatedId,
        }));
    }
    catch (err) {
        var message = 'Failed to write identify throttle to session storage';
        logger.warn({ err: err, message: message, context: 'RudderstackDefaultTracking' }, message);
    }
}
export var RudderstackIdentifyTracking = function (_a) {
    var identifyCallProps = _a.identifyCallProps;
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    useEffect(function () {
        var _a, _b, _c, _d;
        if (!RudderstackClient)
            return;
        if (shouldIdentify(identifyCallProps)) {
            RudderstackClient.identify(identifyCallProps.federatedId, {
                federated_id: identifyCallProps.federatedId,
                is_logged_in: identifyCallProps.isLoggedIn,
                cf_bot_score: (_a = identifyCallProps.cloudflare) === null || _a === void 0 ? void 0 : _a.botScore,
                cf_device_type: (_b = identifyCallProps.cloudflare) === null || _b === void 0 ? void 0 : _b.deviceType,
                cf_ip_country: (_c = identifyCallProps.cloudflare) === null || _c === void 0 ? void 0 : _c.ipCountry,
                cf_ja4: (_d = identifyCallProps.cloudflare) === null || _d === void 0 ? void 0 : _d.ja4,
            });
            recordIdentify(identifyCallProps);
        }
    }, [RudderstackClient, identifyCallProps]);
    return null;
};
